/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CurrentUserService, Profile } from '@administration-client/user-shared';
import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { StateResource } from '@common/tech-shared';
import { Observable } from 'rxjs';
import { ProfileDataComponent } from './profile-data/profile-data.component';

@Component({
  selector: 'administration-profile-data-container',
  imports: [AsyncPipe, ProfileDataComponent],
  templateUrl: './profile-data-container.component.html',
})
export class ProfileDataContainerComponent {
  private readonly currentUserService: CurrentUserService = inject(CurrentUserService);

  public readonly profile: Profile = this.currentUserService.getProfile();
  public readonly organisationsEinheitenStateResource$: Observable<StateResource<string[]>> =
    this.currentUserService.getOrganisationsEinheiten();
}
